/**
 * Created by rickborst on 24/04/2017.
 */

import TYPES from '../types';

/**
 * Creates an invalid response error.
 *
 * @param {Object} [response] - Response.
 * @constructor
 */
export function InvalidResponse (response) {

    this.name = TYPES.API_ERROR;
    this.message = 'Invalid response';
    this.response = response || null;
    this.stack = (new Error()).stack;
}


// WEBPACK FOOTER //
// ./src/js/errors/api/invalidresponse.js